import _defineProperty from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  class: "coupon-detail-desc"
};
var _hoisted_2 = {
  class: "section"
};
var _hoisted_3 = {
  class: "label"
};
var _hoisted_4 = {
  class: "value"
};
var _hoisted_5 = {
  key: 0,
  class: "section"
};
var _hoisted_6 = {
  class: "label"
};
var _hoisted_7 = {
  class: "value hightlight"
};
var _hoisted_8 = {
  key: 1,
  class: "section"
};
var _hoisted_9 = {
  class: "label"
};
var _hoisted_10 = {
  class: "value"
};
var _hoisted_11 = {
  key: 2,
  class: "section"
};
var _hoisted_12 = {
  class: "label"
};
var _hoisted_13 = {
  class: "value"
};
var _hoisted_14 = {
  class: "section"
};
var _hoisted_15 = {
  class: "label"
};
var _hoisted_16 = {
  class: "desc-list"
};
var _hoisted_17 = {
  key: 3,
  class: "section"
};
var _hoisted_18 = {
  class: "label"
};
var _hoisted_19 = {
  class: "value"
};
var _hoisted_20 = {
  key: 4,
  class: "section"
};
var _hoisted_21 = {
  class: "label"
};
var _hoisted_22 = {
  class: "value"
};
var _hoisted_23 = {
  class: "section"
};
var _hoisted_24 = {
  class: "label"
};
var _hoisted_25 = {
  class: "desc-list"
};
var _hoisted_26 = {
  key: 5,
  class: "section"
};
var _hoisted_27 = {
  class: "label"
};
var _hoisted_28 = {
  class: "value"
};
import { priceUtil } from "@op/shared";
import { CouponResourceEnum, CouponStatusEnum, DiscountTypeEnum, CouponUseOrderType } from "@/constant/coupon";
import { getOrderTypeLabelMap } from "@/constant/order";
import { formatPercent, formatDateWithTZ } from "@/utils/format";
import { isDef } from "@/utils/isUtil";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
export default {
  __name: 'CouponDetailDesc',
  props: {
    isMy: {
      type: Boolean,
      default: false
    },
    coupon: {
      type: [Object, null],
      required: true
    }
  },
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var props = __props;
    var sourceText = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, CouponResourceEnum.NEWCOMER_ACTIVITY, t("getFromNewcomerBonus")), CouponResourceEnum.POINTS_MALL, t("getFromRedeem")), CouponResourceEnum.DIRECT, t("getFromMerchant")), CouponResourceEnum.SHARING_ACTIVITY, t("getFromSharingActivity")), CouponResourceEnum.SEND_COUPON_ACTIVITY, t("sendCouponActivity")), CouponResourceEnum.RANDOM_COUPON_ACTIVITY, t("randomCouponActivity")), CouponResourceEnum.BIRTHDAY_ACTIVITY, t("getFromBirthdayActivity"));
    var isFixedCoupon = computed(function () {
      return props.coupon.coupon_info.discount_type === DiscountTypeEnum.FIXED;
    });
    var desc = computed(function () {
      var couponInfo = props.coupon.coupon_info;
      var discountRule = couponInfo.discount_rule;
      if (isFixedCoupon.value) {
        return t("enjoyNOffYourOrder", [priceUtil.formatBaseUnitToShowPrice(discountRule.discount, discountRule.currency)]);
      }
      return t("enjoyNOffYourOrder", [formatPercent(couponInfo.discount_rule.discount_percent)]);
    });
    var conditions = computed(function () {
      var couponInfo = props.coupon.coupon_info;
      var discountRule = couponInfo.discount_rule;
      var shopScope = couponInfo === null || couponInfo === void 0 ? void 0 : couponInfo.shop_scope;
      var dishScope = couponInfo === null || couponInfo === void 0 ? void 0 : couponInfo.dishes_scope;
      var usingRestriction = couponInfo === null || couponInfo === void 0 ? void 0 : couponInfo.using_restriction;
      var OrderTypeLabelMap = getOrderTypeLabelMap();
      var arr = [];
      // 有效期
      var usingTimeRule = couponInfo.using_time_rule;
      if ((usingTimeRule === null || usingTimeRule === void 0 ? void 0 : usingTimeRule.expired_interval) > 0) {
        arr.push(t("validForNDays", [usingTimeRule.expired_interval]));
      }
      // 叠加规则
      arr.push(t("notApplicableWithOtherVouchers"));
      // 使用方式
      arr.push("".concat(t("applicableFor"), " ").concat(couponInfo.order_types.map(function (t) {
        return OrderTypeLabelMap[t];
      }).join(","), "."));
      // 使用门槛
      if (discountRule.min_consumption) {
        arr.push(t("minimumSpendOfNIsRequired", [priceUtil.formatBaseUnitToShowPrice(discountRule.min_consumption, discountRule.currency)]));
      }
      // 最高使用规则
      if (!isFixedCoupon.value) {
        arr.push(t("maximumReductionN", [priceUtil.formatBaseUnitToShowPrice(discountRule.max_discount, discountRule.currency)]));
      }
      // 适用门店范围
      if (!!shopScope) {
        var shopNameList = shopScope === null || shopScope === void 0 ? void 0 : shopScope.scope_names;
        // 适用所有店铺
        if ((shopScope === null || shopScope === void 0 ? void 0 : shopScope.scope_type) === "all") {
          arr.push(t("applyToAllStores"));
        } else if ((shopScope === null || shopScope === void 0 ? void 0 : shopScope.scope_type) === "exclude_shops") {
          // 排除某些店铺不可用
          var str = "";
          shopNameList.forEach(function (item, index) {
            str += item + "";
            if (index < shopNameList.length - 1) str += ",";
          });
          arr.push(t("noApplyToSomeStores", [str]));
        } else {
          // 某些店铺可用
          var _str = "";
          shopNameList.forEach(function (item, index) {
            _str += item + "";
            if (index < shopNameList.length - 1) _str += ",";
          });
          arr.push(t("applyToSomeStores", [_str]));
        }
      }
      // 适用菜品范围
      if (!!dishScope) {
        var dishesNameList = dishScope === null || dishScope === void 0 ? void 0 : dishScope.scope_names;
        // 适用所有
        if ((dishScope === null || dishScope === void 0 ? void 0 : dishScope.scope_type) === "all") {
          arr.push(t("applyToAllProduct"));
        } else if ((dishScope === null || dishScope === void 0 ? void 0 : dishScope.scope_type) === "dishes") {
          // 某些菜品可用
          var _str2 = "";
          dishesNameList.forEach(function (item, index) {
            _str2 += item + "";
            if (index < dishesNameList.length - 1) _str2 += ",";
          });
          arr.push(t("applyToSomeProduct", [_str2]));
        } else {
          // 某些分类可用
          var _str3 = "";
          dishesNameList.forEach(function (item, index) {
            _str3 += item + "";
            if (index < dishesNameList.length - 1) _str3 += ",";
          });
          arr.push(t("applyToSomeCategory", [_str3]));
        }
      }
      // 是否只可兑换一次
      if (props.coupon.limit_repurchase) {
        arr.push(t("thisVoucherCanOnlyBeRedeemedOnce"));
      }
      if (usingRestriction && usingRestriction.once_a_day) {
        arr.push(t("usageRestrictionOnlyOneCanBeUsedPerDay"));
      }
      if (usingRestriction && usingRestriction.week_days) {
        arr.push(t("dateRestrictionOnlyAvailable", [usingRestriction.week_days.join(",")]));
      }
      return arr;
    });
    var remarks = computed(function () {
      return [t("applicableProductsOrServices"), t("quantityLimitsOneCouponPerTransaction"), t("notBeCombinedWithOtherOffers"), t("nonRefundableOrRedeemable"), t("termModifications"), t("abuseProvision")];
    });
    var diffDay = function diffDay(endTime) {
      return Math.ceil((endTime - Date.now()) / (24 * 60 * 60 * 1000));
    };
    var genValidTimeTip = function genValidTimeTip() {
      if (props.coupon.status === CouponStatusEnum.INEFFECTIVE) {
        return t("effectiveTheNextDay");
      }
      if (props.coupon.status === CouponStatusEnum.UNUSED) {
        var days = diffDay(props.coupon.end_time);
        if (days <= 3) {
          return t("expiresInNDays", [days]);
        }
      }
      return "";
    };
    var isShowVerfitype = computed(function () {
      var couponInfo = props.coupon.coupon_info;
      if ((couponInfo.order_types.includes(CouponUseOrderType.DINE_IN) || couponInfo.order_types.includes(CouponUseOrderType.TAKEAWAY)) && !couponInfo.order_types.includes(CouponUseOrderType.SELF_DELIVERY) && !couponInfo.order_types.includes(CouponUseOrderType.SELF_PICK_UP)) {
        return true;
      }
      return false;
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("description")), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(desc.value), 1)]), _unref(isDef)(__props.coupon.coupon_info.discount_rule.min_consumption) ? (_openBlock(), _createElementBlock("section", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("minimumSpend")), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(priceUtil).formatBaseUnitToShowPrice(__props.coupon.coupon_info.discount_rule.min_consumption, __props.coupon.coupon_info.discount_rule.currency)), 1)])) : _createCommentVNode("", true), __props.coupon.obtain_time ? (_openBlock(), _createElementBlock("section", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("receivedDate")), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(formatDateWithTZ)(__props.coupon.obtain_time, "YYYY-MM-DD")), 1)])) : _createCommentVNode("", true), __props.coupon.end_time ? (_openBlock(), _createElementBlock("section", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createTextVNode(_toDisplayString(_ctx.$t("validPeriod")) + " ", 1), genValidTimeTip() ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["tip", __props.coupon.status])
      }, "(" + _toDisplayString(genValidTimeTip()) + ")", 3)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(formatDateWithTZ)(__props.coupon.start_time, "YYYY-MM-DD HH:mm:ss")) + " ~ " + _toDisplayString(_unref(formatDateWithTZ)(__props.coupon.end_time, "YYYY-MM-DD HH:mm:ss")), 1)])) : _createCommentVNode("", true), _createElementVNode("section", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("termsAndConditions")), 1), _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conditions.value, function (text) {
        return _openBlock(), _createElementBlock("div", {
          key: text,
          class: "desc-item"
        }, [_cache[0] || (_cache[0] = _createElementVNode("div", {
          class: "dot"
        }, "•", -1)), _createElementVNode("div", null, _toDisplayString(text), 1)]);
      }), 128))])]), __props.coupon.used_time ? (_openBlock(), _createElementBlock("section", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("usedTime")), 1), _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(formatDateWithTZ)(__props.coupon.used_time, "YYYY-MM-DD HH:mm:ss")), 1)])) : _createCommentVNode("", true), __props.coupon.obtain_source ? (_openBlock(), _createElementBlock("section", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("couponSource")), 1), _createElementVNode("div", _hoisted_22, [_createTextVNode(_toDisplayString(sourceText[__props.coupon.obtain_source]) + " ", 1), _createElementVNode("p", null, _toDisplayString(_unref(formatDateWithTZ)(__props.coupon.obtain_time, "YYYY-MM-DD HH:mm:ss")), 1)])])) : _createCommentVNode("", true), _createElementVNode("section", _hoisted_23, [_createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("remarks")), 1), _createElementVNode("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(remarks.value, function (text) {
        return _openBlock(), _createElementBlock("div", {
          key: text,
          class: "desc-item"
        }, [_cache[1] || (_cache[1] = _createElementVNode("div", {
          class: "dot"
        }, "•", -1)), _createElementVNode("div", null, _toDisplayString(text), 1)]);
      }), 128))])]), isShowVerfitype.value ? (_openBlock(), _createElementBlock("section", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("usageRestrictions")), 1), _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("thisVoucherCanOnlyBeUsedInStore")), 1)])) : _createCommentVNode("", true)]);
    };
  }
};